var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f57c00;}.cls-2{fill:#999;}.cls-3{fill:#666;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "outline color",
    id: "outline_color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,50H48a1,1,0,0,1,0-2h5V40a8,8,0,0,0-8-8,8,8,0,0,0-8,8v8h5a1,1,0,0,1,0,2H36a1,1,0,0,1-1-1V40A10,10,0,0,1,45,30,10,10,0,0,1,55,40v9A1,1,0,0,1,54,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,51a6,6,0,0,1-6-6V40a6,6,0,0,1,12,0v5A6,6,0,0,1,45,51Zm0-15a4,4,0,0,0-4,4v5a4,4,0,0,0,8,0V40A4,4,0,0,0,45,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.5,41h-11a1,1,0,0,1,0-2h11a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.24,54.38a3.07,3.07,0,0,1-3.06-3.07V49.66a1,1,0,0,1,2,0v1.65a1.06,1.06,0,1,0,2.12,0V49.44a1,1,0,0,1,2,0v1.87A3.07,3.07,0,0,1,45.24,54.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.5,60h-24a1,1,0,0,1-1-1,7.87,7.87,0,0,1,7.87-7.88h2.81a1,1,0,0,1,0,2H40.37a5.81,5.81,0,0,0-4.15,1.73A5.87,5.87,0,0,0,34.58,58H56.42a5.89,5.89,0,0,0-5.79-4.88H47.3a1,1,0,0,1,0-2h3.33A7.88,7.88,0,0,1,58.5,59,1,1,0,0,1,57.5,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,43H57a1,1,0,0,1,0-2h1V39.58C58,33.19,52.47,28,45.68,28H44.32C37.53,28,32,33.19,32,39.58V41h1a1,1,0,0,1,0,2H31a1,1,0,0,1-1-1V39.58C30,32.09,36.42,26,44.32,26h1.36C53.58,26,60,32.09,60,39.58V42A1,1,0,0,1,59,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,44a1,1,0,0,1-1-1V41a1,1,0,0,1,2,0v2A1,1,0,0,1,33,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,44a1,1,0,0,1-1-1V41a1,1,0,0,1,2,0v2A1,1,0,0,1,57,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.78,55.1a5,5,0,0,1-4.57-3L4.56,23.84a5,5,0,0,1,2.52-6.61L28,7.9a1,1,0,1,1,.82,1.82L7.9,19.05a3,3,0,0,0-1.52,4L19,51.32a3,3,0,0,0,4,1.52L31.59,49a1,1,0,1,1,.82,1.82l-8.6,3.84A4.89,4.89,0,0,1,21.78,55.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.83,28.21a1,1,0,0,1-.92-.59,2.74,2.74,0,0,1,.38-2.79,1,1,0,0,0-1-1.58,1,1,0,0,0-.67.53,1,1,0,0,0,0,.85,1,1,0,0,1-1.83.82,3,3,0,1,1,5.13.58.78.78,0,0,0-.14.77,1,1,0,0,1-.5,1.32A1,1,0,0,1,14.83,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16,30.83l-.2,0-.19-.06-.17-.09a.93.93,0,0,1-.15-.13,1,1,0,0,1-.29-.7,1,1,0,0,1,.07-.39,1,1,0,0,1,.22-.32.93.93,0,0,1,.15-.13l.17-.09.19-.06a1,1,0,0,1,1.12.6,1,1,0,0,1,.08.39,1,1,0,0,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.32,38.69a1,1,0,0,1-.91-.59,2.94,2.94,0,0,1-.07-2.29A3,3,0,0,1,18,34.13a1,1,0,1,1,.8,1.82,1.06,1.06,0,0,0-.54.58,1,1,0,0,0,0,.75,1,1,0,0,1-.5,1.32A1,1,0,0,1,17.32,38.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.65,43.48a1.05,1.05,0,0,1-.71-.29,1,1,0,0,1-.29-.71,1,1,0,0,1,.08-.38,1,1,0,0,1,.21-.33,1,1,0,0,1,1.42,0,1,1,0,0,1,.21.33.84.84,0,0,1,.08.38,1,1,0,0,1-.29.71A1.05,1.05,0,0,1,21.65,43.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.47,21.45a1,1,0,0,1-.41-1.91l5.37-2.4A1,1,0,0,1,25.25,19l-5.37,2.4A1,1,0,0,1,19.47,21.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.11,25.1a1,1,0,0,1-.41-1.91l1.71-.76a1,1,0,0,1,.82,1.82L21.52,25A1,1,0,0,1,21.11,25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27,45.34a.92.92,0,0,1-.36-.07l-6.92-2.65a5,5,0,0,1-2.87-6.45l11.06-29a5,5,0,0,1,6.45-2.89L56.79,12.9a5,5,0,0,1,2.89,6.45L56.9,26.62A1,1,0,0,1,55,25.9l2.77-7.26a3,3,0,0,0-1.74-3.88L33.65,6.19a3,3,0,0,0-3.88,1.74l-11.06,29a3,3,0,0,0,.07,2.3,2.91,2.91,0,0,0,1.65,1.56l6.93,2.66A1,1,0,0,1,27,45.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.79,17.87a.92.92,0,0,1-.36-.07,1,1,0,0,1-.58-1.29,2.75,2.75,0,0,1,2.24-1.71,1,1,0,0,0,.85-.82,1,1,0,0,0-.46-1,1,1,0,0,0-1.46.49,1,1,0,0,1-1.87-.71,3,3,0,1,1,3.22,4,.76.76,0,0,0-.65.45A1,1,0,0,1,32.79,17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.76,20.54a1,1,0,0,1-.7-.29,1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0,1.19,1.19,0,0,1,.22.33,1,1,0,0,1-.93,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.84,30.82a.92.92,0,0,1-.36-.07,1,1,0,0,1-.58-1.29,2.72,2.72,0,0,1,2.24-1.71,1,1,0,0,0,.85-.82,1,1,0,0,0-.46-1,1,1,0,0,0-.85-.1,1,1,0,0,0-.61.59,1,1,0,0,1-1.87-.71,3,3,0,1,1,3.22,4,.77.77,0,0,0-.65.44A1,1,0,0,1,27.84,30.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.81,33.49l-.19,0a.6.6,0,0,1-.19-.06.56.56,0,0,1-.17-.09l-.15-.12a1,1,0,0,1,.9-1.69,1.08,1.08,0,0,1,.36.15,1.58,1.58,0,0,1,.15.12,1,1,0,0,1,0,1.42l-.15.12a1.08,1.08,0,0,1-.36.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.26,19.59a.92.92,0,0,1-.36-.07l-8.41-3.21A1,1,0,0,1,39.92,15a1,1,0,0,1,1.29-.58l8.41,3.21a1,1,0,0,1-.36,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.63,24.4a1.15,1.15,0,0,1-.36-.07L39.06,20a1,1,0,0,1,.72-1.86L51,22.46a1,1,0,0,1-.36,1.94Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsult);
export default __webpack_public_path__ + "static/media/consult.91fe2e482c7adc0b75bbe666a0e5b6a8.svg";
export { ForwardRef as ReactComponent };